import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=4794ef42&"
import script from "./barChart.vue?vue&type=script&lang=js&"
export * from "./barChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports